import { useLayoutEffect, useState } from 'react'

export enum DeviceOrientation {
  Portrait,
  Landscape,
}

interface ScreenOrientationEvent {
  target?: {
    type:
      | 'portrait-primary'
      | 'portrait-secondary'
      | 'landscape-primary'
      | 'landscape-secondary'
  }
}

const fallback = () => {
  return window.innerHeight > window.innerWidth
    ? DeviceOrientation.Portrait
    : DeviceOrientation.Landscape
}

export const useDeviceOrientation = (): DeviceOrientation => {
  const [orientation, setOrientation] = useState<DeviceOrientation>(fallback)
  const screenOrientation = screen?.orientation

  useLayoutEffect(() => {
    const listener = (event: ScreenOrientationEvent) => {
      const type = event?.target?.type

      if (type?.startsWith('portrait')) {
        setOrientation(DeviceOrientation.Portrait)
      } else {
        setOrientation(DeviceOrientation.Landscape)
      }
    }

    const resizeListener = () => {
      setOrientation(fallback())
    }

    if (screenOrientation) {
      // @ts-expect-error - TS doesn't know about the change event
      screenOrientation.addEventListener('change', listener)
    } else {
      window.addEventListener('resize', resizeListener)
    }

    return () => {
      if (screenOrientation) {
        // @ts-expect-error - TS doesn't know about the change event
        screenOrientation.removeEventListener('change', listener)
      } else {
        window.removeEventListener('resize', resizeListener)
      }
    }
  }, [])

  return orientation
}
